import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "@/utils/useElement.js"
// 接口配置文件
import "@/api/index.js"

import "swiper/dist/css/swiper.min.css"
import "swiper/dist/js/swiper.min"

import "../node_modules/wowjs/css/libs/animate.css"
import { WOW } from "wowjs"
Vue.prototype.$wow = WOW

import MetaInfo from "vue-meta-info"
Vue.use(MetaInfo)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted () {
    document.dispatchEvent(new Event("render-event"))
  },
}).$mount("#app")
